import React from "react";

export const PasswordShowIcon = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2571 10.962C21.7311 11.582 21.7311 12.419 21.2571 13.038C19.7641 14.987 16.1821 19 12.0001 19C7.81806 19 4.23606 14.987 2.74306 13.038C2.51211 12.7413 2.38672 12.376 2.38672 12C2.38672 11.624 2.51211 11.2587 2.74306 10.962C4.23606 9.013 7.81806 5 12.0001 5C16.1821 5 19.7641 9.013 21.2571 10.962Z"
        stroke="#959595"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="#959595"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
